import { useTranslation } from "react-i18next"

interface AdvancedCareProviderSearchEmptyProps {
  title: string
  message: string
}

const AdvancedCareProviderSearchEmpty = ({ title, message }: AdvancedCareProviderSearchEmptyProps) => {
  const { t } = useTranslation()
  return (
    <div className="flex h-full items-center justify-center gap-4 p-3 text-center">
      <div className="grid gap-1">
        <h2 data-testid="no-results-title" className="text-on-surface text-xl font-bold">
          {t(title)}
        </h2>
        <span data-testid="no-results-message" className="text-on-surface-subdued text-base">
          {t(message)}
        </span>
      </div>
    </div>
  )
}

export default AdvancedCareProviderSearchEmpty
